import * as React from "react";
import { Helmet } from "react-helmet";
import {
  ORGANIZATION_CONTACT_EMAIL,
  ORGANIZATION_CONTACT_URL,
  ORGANIZATION_DESCRIPTION,
  ORGANIZATION_ID,
  ORGANIZATION_LEGAL_NAME,
  ORGANIZATION_LOGO_URL,
  ORGANIZATION_NAME,
  ORGANIZATION_SAME_AS,
} from "../../constants/organization-schema";
import { CANONICAL_HOMEPAGE_URL } from "../../constants/site-urls";

export function OrganizationJsonLd(): React.ReactElement {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": ORGANIZATION_ID,
    name: ORGANIZATION_NAME,
    legalName: ORGANIZATION_LEGAL_NAME,
    url: CANONICAL_HOMEPAGE_URL,
    logo: ORGANIZATION_LOGO_URL,
    image: ORGANIZATION_LOGO_URL,
    description: ORGANIZATION_DESCRIPTION,
    sameAs: [...ORGANIZATION_SAME_AS],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      email: ORGANIZATION_CONTACT_EMAIL,
      url: ORGANIZATION_CONTACT_URL,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
